import {skipToken} from '@reduxjs/toolkit/query';
import {isFeatureEnabled} from 'feature-flags';
import {match, Pattern} from 'ts-pattern';

import {always} from 'ramda';

import {useSmsGetKonzultaCredentialsQuery} from '@dms/api/core';
import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';

/**
 * Single source of truth for whether the Konzulta SMS action is available and
 * which tooltip should explain its state. Gates on both the `KONZULTA_SMS`
 * feature flag and the tenant's Konzulta configuration so every SMS entry point
 * (activity panel, entity headers, customer detail, action parameters, ...)
 * disables identically and shows a consistent tooltip.
 */
export function useKonzultaSmsAvailability() {
  const isSmsServiceEnabled = isFeatureEnabled(featureFlags.KONZULTA_SMS);
  const {
    data: konzultaConfig,
    isLoading,
    isError,
  } = useSmsGetKonzultaCredentialsQuery(isSmsServiceEnabled ? undefined : skipToken);

  const isKonzultaConfigured = konzultaConfig?.enabled === true;
  const isSmsActionDisabled = !isSmsServiceEnabled || !isKonzultaConfigured;

  const smsTooltipLabel = match([isSmsServiceEnabled, isKonzultaConfigured])
    .with([false, Pattern.boolean], always(i18n.t('general.notifications.smsServiceUnavailable')))
    .with([true, false], always(i18n.t('general.notifications.setupSmsProvider')))
    .otherwise(always(i18n.t('general.actions.sendMessage')));

  return {
    isSmsServiceEnabled,
    isKonzultaConfigured,
    isSmsActionDisabled,
    smsTooltipLabel,
    isLoading,
    isError,
  };
}
